module.exports = __webpack_public_path__ + "img/bizpic1.e5c0a303.jpg";